"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ToggleWrapper = exports.ToggleFilter = exports.ImagesWrapper = exports.ImageWrapper = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var ToggleFilter = _styledComponents["default"].div.withConfig({
  displayName: "ToggleFilterstyle__ToggleFilter",
  componentId: "sc-uivxai-0"
})(function (props) {
  return (0, _styledComponents.css)(["display:flex;align-items:center;justify-content:space-between;", ";width:100%;& > div[class*='ToggleFilter']{&:first-of-type{flex-grow:1;flex-shrink:1;flex-basis:0;}}"], props.theme.mixins.spacing('padding-bottom', 3));
});

exports.ToggleFilter = ToggleFilter;

var ImagesWrapper = _styledComponents["default"].div.withConfig({
  displayName: "ToggleFilterstyle__ImagesWrapper",
  componentId: "sc-uivxai-1"
})(function () {
  return (0, _styledComponents.css)(["display:flex;"]);
});

exports.ImagesWrapper = ImagesWrapper;

var ImageWrapper = _styledComponents["default"].div.withConfig({
  displayName: "ToggleFilterstyle__ImageWrapper",
  componentId: "sc-uivxai-2"
})(function (props) {
  return (0, _styledComponents.css)(["", ";"], props.theme.mixins.spacing('margin-right', 2));
});

exports.ImageWrapper = ImageWrapper;

var ToggleWrapper = _styledComponents["default"].div.withConfig({
  displayName: "ToggleFilterstyle__ToggleWrapper",
  componentId: "sc-uivxai-3"
})(function () {
  return (0, _styledComponents.css)(["display:flex;justify-content:space-between;& > div{&[class*='Toggle']{flex-grow:1;flex-shrink:1;flex-basis:0;}}"]);
});

exports.ToggleWrapper = ToggleWrapper;
//# sourceMappingURL=ToggleFilter.style.js.map